module.exports = __webpack_public_path__ + "img/22.b5ee7b21.webp";